import React, { useEffect } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
// reactstrap components
import { Container } from "reactstrap";
// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import routes from "routes.js";
import ParentsSidebar from "components/Sidebar/ParentsSidebar";
import ParentFooter from "components/Footers/ParentFooter";
import { useAuthContext } from "hooks/useAuthContext";

export default function ParentLayout(props) {
    const mainContent = React.useRef(null);
    const location = useLocation();
    const {user} = useAuthContext()
    // React.useEffect(() => {
    //   document.documentElement.scrollTop = 0;
    //   document.scrollingElement.scrollTop = 0;
    //   mainContent.current.scrollTop = 0;
    // }, [location]);
    useEffect(() => {
    
      if (user) {
        if (window.location.href.startsWith('http://localhost:3000/register')) {
          const searchParams = new URLSearchParams(window.location.search);
          const id = searchParams.get("id");
          const age = searchParams.get("age");
        
          const data = localStorage.getItem("member");
          if (data) {
            const members = JSON.parse(data);
            const matchedMember = members.find(mem => mem.age == age);
        
            if (matchedMember) {
              const member_id = matchedMember.id || matchedMember.member_id; // adjust field name as needed
              window.location.href = `/parents/course-details/${id}/${member_id}`;
            }
          }
        }      
      }
     
    },[])
    const getRoutes = (routes) => {
      return routes.map((prop, key) => {
        if (prop.layout === "/parent") {
          return (
            <Route path={prop.path} element={prop.component} key={key} exact />
          );
        } else {
          return null;
        }
      });
    };
  
    const getBrandText = (path) => {
      for (let i = 0; i < routes.length; i++) {
        if (
          props?.location?.pathname.indexOf(routes[i].layout + routes[i].path) !==
          -1
        ) {
          return routes[i].name;
        }
      }
      return "Brand";
    };
  return (
    <div>
          <ParentsSidebar
        {...props}
        routes={routes}
        logo={{
          innerLink: "/parent/courses",
          imgSrc: require("../assets/img/brand/Japalouppe_Logo_navy.png"),
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props?.location?.pathname)}
        />
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/parent/index" replace />} />
        </Routes>
        <Container fluid>
          <ParentFooter />
        </Container>
      </div>
    </div>
  )
}
